import { BudgetScenarioWorktypeOption } from '@callmart/types';
import api from './index';

const BASE = '/budget-scenarios';

export interface ScenarioDriverValue {
    month: string; // 'YYYY-MM-DD'
    driverDelta: number; // monthly business-driver change (CB/GA/VVL); may be negative
}

export interface ScenarioDriverRow {
    id: number;
    worktypeId: number;
    worktypeName: string | null;
    wlPer1000: number;
    cpc: number;
    headsTraining: number;
    trainingDays: number;
    costPerHour: number;
    trainerResource: number;
    /** The training allocation window (CALL-801); null trainingStart = walk from the scenario start. */
    trainingStart: string | null;
    trainingEnd: string | null;
    values: ScenarioDriverValue[];
}

export interface ScenarioDriverRowsResponse {
    /** The scenario's `updatedAt` AS OF this read — the revision the form's next PATCH must send with THESE
     *  rows (see ScenarioContactValuesResponse.revision for why the scenario query cannot supply it). */
    revision: string;
    rows: ScenarioDriverRow[];
    availableWorktypes: BudgetScenarioWorktypeOption[];
}

/** `versionId` is the version the OPTION lists must describe — the DRAFT one while the detail form's
 *  Budget select is pointed elsewhere, so the pickers stay in step with the impact preview (which is
 *  already priced against that version). Omitted, the server answers from the scenario's stored one. */
export const getScenarioDriverRows = async (
    scenarioId: number,
    versionId?: number
): Promise<ScenarioDriverRowsResponse> => {
    return api.get(`${BASE}/${scenarioId}/driver-rows`, { params: { versionId } }).then((res) => res.data);
};
